import { useQuery } from 'react-query';
import { cacheKeys } from './cacheKeys';
import { handleRequest } from '../../redux/services/APIService';

export const useGetBroadcasts = (options = {}) => {
  const { page = 1, limit = 50, ...queryOptions } = options;

  return useQuery(
    cacheKeys.getBroadcasts({ page, limit }),
    async () => {
      const response = await handleRequest(
        'get',
        'broadcasts',
        true,
        null,
        { page, limit },
      );

      return response.data;
    },
    {
      onError: (error) => {
        console.error(
          `${error.response?.data?.data?.resultMessage || error.message}`,
        );
      },
      ...queryOptions,
    },
  );
};
